import { replaceOperation } from '../../product/operations';
import { editFiles } from '../files';

import { ATTRIBUTE } from '../../../constants/attributes';
import { VALUE } from '../../../constants/product';
import { EMPTY } from '../../../constants';
import { FORM } from '../../../constants/forms';

export function files({ operation, product, ...rest }) {
  if (!product.getIn([FORM.DETAILS, ATTRIBUTE.DIGITAL, VALUE])) {
    return { product, ...rest };
  }

  const value = operation.get('value');
  const updates = editFiles({ product, value });

  return {
    ...rest,
    product: updates.product = updates.product.set('operations',
      updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
    ),
  };
}
